
import { Component, Vue, Watch } from "vue-property-decorator";
import { SMQuestionnaire, SMCases } from "@/store";
import { API_ROUTES } from "@/utils/API";
import { TStep } from "@/models/questionnaire";

const CURRENT_STEP_MODEL = {
  title: "",
  subtitle: "",
  is_required: true,
};

const DEFAULT_DYNAMIC_COMPONENT_MODEL = {
  name: "",
  props: {},
};

const LOAD_ELEMENT_FRONT_CONDITION = "LOAD_ELEMENT";

const DISPLAY_NAME_CREATE = "Create a role template";

@Component({
  components: {
    "ons-data-soc-component": () => import("@/components/SocTable/OnsDataSocComponent.vue"),
    AnswerBlocks: () => import("./components/AnswerBlocks/AnswerBlocks.vue"),
    AnswerBlocksLoop: () => import("./components/AnswerBlocks/AnswerBlocksLoop.vue"),
  },
})
export default class QuestionnaireBody extends Vue {
  get currentStep() {
    if (SMQuestionnaire.currentStep == null) return CURRENT_STEP_MODEL;

    return SMQuestionnaire.currentStep?.question;
  }

  get optionalLabel() {
    return this.currentStep.is_required ? "" : "(Optional)";
  }

  $refs!: {
    question: HTMLFormElement;
  };

  beforeUpdate() {
    this.$refs.question.scrollTop = 0;
  }

  get stepInstance() {
    return SMQuestionnaire.currentStep;
  }

  dynamicComponent = { ...DEFAULT_DYNAMIC_COMPONENT_MODEL };

  @Watch("stepInstance", { immediate: true, deep: true })
  onStepChange(payload: TStep) {
    this.dynamicComponent = { ...DEFAULT_DYNAMIC_COMPONENT_MODEL };

    if (!payload) return;

    this.fetchCondition(payload.front_condition);
  }

  @Watch("loopsCount")
  loopsCountChanged(val: number) {
    this.$refs.question.scrollTop = val !== 1 ? this.$refs.question.scrollHeight : 0;
  }

  get loopsCount() {
    return SMQuestionnaire.loopsCount;
  }

  async fetchCondition(condition: string) {
    const parts = condition.split(" ");

    if (parts[0] === LOAD_ELEMENT_FRONT_CONDITION) {
      const firstConditionParts = parts[1].split("=");

      const case_id = SMCases.caseId;

      const body =
        SMQuestionnaire.display_name === DISPLAY_NAME_CREATE
          ? { ...SMQuestionnaire.getAnswerQuery }
          : { ...SMQuestionnaire.getAnswerQuery, case_id };

      const params = {
        alias: firstConditionParts[1],
        ...body,
      };

      const { data } = await this.axios.get(API_ROUTES.GET_ANSWER_BLOCK(), { params });

      if (!data || !data.alias_result) return;

      this.dynamicComponent = {
        name: firstConditionParts[0],
        props: {
          value: data.alias_result,
        },
      };
    }
  }
}
